import { MotorCCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const MotorCCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case MotorCCActionType.MotorCC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default MotorCCReducer
